import brandingColors from '../colors/colors.js';
import { MOBILE_SIDENAV_VARIANT, TAB_VARIANT, LANG_VARIANT, SIGN_IN_VARIANT } from '../components/SideNav/constants.js';
import { GRID_BREAKPOINTS_CANADIAN } from '../spacing/index.js';
import { rem } from '../utils/functions.js';

var canadianTheme = {
  name: 'canadianTheme',
  colorPalette: {
    primaryColors: {
      main: {
        shade_light_4: brandingColors.light_4_green,
        shade_light_3: brandingColors.light_3_green,
        shade_light_2: brandingColors.light_2_green,
        shade_light_1: brandingColors.light_1_green,
        shade_default: brandingColors.m_green,
        shade_link: brandingColors.link_green,
        shade_dark_1: brandingColors.dark_1_green,
        shade_dark_2: brandingColors.dark_2_green,
        shade_dark_3: brandingColors.dark_3_green
      },
      alternate: {
        shade_light_4: brandingColors.light_4_blue,
        shade_light_3: brandingColors.light_3_blue,
        shade_light_2: brandingColors.light_2_blue,
        shade_light_1: brandingColors.light_1_blue,
        shade_default: brandingColors.blue,
        shade_dark_1: brandingColors.dark_1_blue,
        shade_dark_2: brandingColors.dark_2_blue,
        shade_dark_3: brandingColors.dark_3_blue
      }
    },
    neutralColors: {
      dark: {
        shade_light_4: brandingColors.light_4_dark_navy,
        shade_light_3: brandingColors.light_3_dark_navy,
        shade_light_2: brandingColors.light_2_dark_navy,
        shade_light_1: brandingColors.light_1_dark_navy,
        shade_default: brandingColors.dark_navy,
        shade_dark_1: brandingColors.super_dark_navy
      },
      light: {
        shade_white: brandingColors.white,
        shade_light_2: brandingColors.light_2_grey,
        shade_light_1: brandingColors.light_1_grey,
        shade_default: brandingColors.light_grey,
        shade_dark_1: brandingColors.dark_1_light_grey,
        shade_dark_2: brandingColors.dark_2_light_grey,
        shade_dark_3: brandingColors.dark_3_light_grey
      }
    },
    accentColor: {
      shade_light_4: brandingColors.light_4_coral,
      shade_light_3: brandingColors.light_3_coral,
      shade_light_2: brandingColors.light_2_coral,
      shade_light_1: brandingColors.light_1_coral,
      shade_default: brandingColors.coral,
      shade_dark_1: brandingColors.dark_1_coral,
      shade_dark_2: brandingColors.dark_2_coral,
      shade_dark_3: brandingColors.dark_3_coral
    },
    secondaryColors: {
      one: {
        shade_light_4: brandingColors.light_4_violet,
        shade_light_3: brandingColors.light_3_violet,
        shade_light_2: brandingColors.light_2_violet,
        shade_light_1: brandingColors.light_1_violet,
        shade_default: brandingColors.violet,
        shade_dark_1: brandingColors.dark_1_violet,
        shade_dark_2: brandingColors.dark_2_violet,
        shade_dark_3: brandingColors.dark_3_violet
      },
      two: {
        shade_light_4: brandingColors.light_4_gold,
        shade_light_3: brandingColors.light_3_gold,
        shade_light_2: brandingColors.light_2_gold,
        shade_light_1: brandingColors.light_1_gold,
        shade_default: brandingColors.gold,
        shade_dark_1: brandingColors.dark_1_gold,
        shade_dark_2: brandingColors.dark_2_gold,
        shade_dark_3: brandingColors.dark_3_gold
      },
      three: {
        shade_light_4: brandingColors.light_4_turquoise,
        shade_light_3: brandingColors.light_3_turquoise,
        shade_light_2: brandingColors.light_2_turquoise,
        shade_light_1: brandingColors.light_1_turquoise,
        shade_default: brandingColors.turquoise,
        shade_dark_1: brandingColors.dark_1_turquoise,
        shade_dark_2: brandingColors.dark_2_turquoise,
        shade_dark_3: brandingColors.dark_3_turquoise
      }
    },
    utilityColors: {
      error: brandingColors.red_error,
      alert: brandingColors.red_error,
      warning: brandingColors.gold,
      info: brandingColors.light_2_blue,
      complete: brandingColors.m_green
    }
  },
  dropdown: {
    native: true
  },
  footer: {
    logo: {
      height: '20px',
      maxWidth: '100%'
    }
  },
  sideNav: {
    brandLogo: {
      showLogo: true,
      height: '100px',
      width: '100px'
    },
    wordmarkLogo: {
      height: '20px',
      maxWidth: '100%'
    },
    mainNav: {
      top: '40px',
      backgroundColor: brandingColors.light_2_dark_navy,
      fontSize: rem(10),
      lineHeight: 1.2,
      iconOpacity: 1
    },
    subNav: {
      item: {
        height: '60px',
        padding: '20px',
        selected: {
          backgroundColor: brandingColors.light_1_grey,
          borderColor: brandingColors.light_1_green,
          fontWeight: 600
        }
      }
    },
    mobile: {
      variant: MOBILE_SIDENAV_VARIANT.ACCORDION,
      color: brandingColors.white,
      backgroundColor: brandingColors.dark_navy,
      toggle: {
        showLabel: true
      },
      item: {
        backgroundColor: brandingColors.light_2_dark_navy,
        height: '60px'
      },
      wordmarkLogo: {
        height: '20px',
        maxWidth: '100%',
        paddingLeft: '18px',
        paddingRight: '18px'
      },
      header: {
        borderColor: 'transparent',
        showTabs: true
      },
      footer: {
        borderColor: brandingColors.light_2_dark_navy,
        showTabs: false
      },
      tab: {
        variant: TAB_VARIANT.LINE,
        height: '50px'
      },
      lang: {
        variant: LANG_VARIANT.LARGE
      },
      searchField: {
        height: '64px'
      },
      signIn: {
        variant: SIGN_IN_VARIANT.GOLD
      }
    }
  },
  utilityHeader: {
    height: '40px',
    backgroundColor: brandingColors.light_2_dark_navy,
    color: brandingColors.white
  },
  gridConfig: {
    default: {
      columns: 16,
      gutterWidth: 16,
      margin: {
        navOpen: 40,
        navClosed: 64
      }
    },
    breakpoints: [{
      breakpoint: GRID_BREAKPOINTS_CANADIAN.XS,
      columns: 4,
      gutterWidth: 16,
      margin: 24
    }, {
      breakpoint: GRID_BREAKPOINTS_CANADIAN.S,
      columns: 4,
      gutterWidth: 16,
      margin: 24
    }, {
      breakpoint: GRID_BREAKPOINTS_CANADIAN.M,
      columns: 12,
      gutterWidth: 16,
      margin: 32
    }, {
      breakpoint: GRID_BREAKPOINTS_CANADIAN.L,
      columns: 12,
      gutterWidth: 16,
      margin: {
        navOpen: 32,
        navClosed: 56
      }
    }, {
      breakpoint: GRID_BREAKPOINTS_CANADIAN.XL,
      columns: 12,
      gutterWidth: 16,
      margin: {
        navOpen: 40,
        navClosed: 64
      }
    }]
  }
};

export default canadianTheme;
